
import { Vue, Component } from "vue-property-decorator";
import { AmTypography } from "@afe/amui/src/components/Typography";
import { AmIcon } from "@afe/amui/src/components/Icon";
import { AmDivider } from "@afe/amui/src/components/Divider";
@Component({
  components: {
    AmTypography,
    AmDivider,
    AmIcon
  }
})
export default class extends Vue {}
